import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'

import Img1 from './create_branch_1.png'
import Img2 from './create_branch_2.png' 
import Img6 from './create_branch_6.png'

function CreateBranchHelper(props) {

    const [showModal, setShowModal] = useState(false)

    return [
        <p
            key='1'
            style={{cursor:"pointer"}}
            onClick={() => setShowModal(true)}
            className='text-danger'
        >
            Ajuda? <i className="fas fa-question"></i>
        </p>,
        <Modal scrollable={true} centered size="lg" show={showModal}>
            <Modal.Header>
                <h4>Como cadastrar uma Filial</h4>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Se a sua empresa for pequena ou média e do regime do Simples Nacional, você marca <strong>Pessoa  Jurídica</strong>, mas se você for MEI, marque a opção <strong>MEI</strong>. Depois disso, clique em Próximo.
                    </p>
                <img className='col-12' src={Img1} />

                <p className='pt-3'>
                    Nessa tela, você coloca os dados da sua empresa. Atenção para os dados solicitados, que você precisa preencher:
                    </p>
                <ul>
                    <li><strong>Inscrição estadual (IE)</strong>: se não souber seu número da Inscrição Estadual, no link abaixo da caixa de texto, você consegue descobrir de forma fácil.</li>
                    <li><strong>CNAE</strong>: se não souber sua Classificação Nacional de Atividade Econômica (CNAE)  principal, basta clicar no link abaixo da caixa de texto, e você será redirecionado(a) para a página de consulta.</li>
                    <li><strong>CRT</strong>: aqui você vai marcar o seu Regime tributário. Se for MEI, provavelmente você é do Simples Nacional (lembrando que no momento, as notas gratuitas são apenas para empresas no Simples Nacional, Pequena e Media ou MEI).</li>
                </ul>
                <p>Após preencher todo o formulário, basta clicar em próximo.</p>
                <img className='col-12' src={Img2} />
                <p className='pt-3'>
                    Em seguida, basta preencher seu endereço, para finalizar o cadastro de filial e passar para a seleção do seu Plano de uso.
                    </p>
                <img className='col-12' src={Img6} />
            </Modal.Body>
            <Modal.Footer>
                <button onClick={() => setShowModal(false)} className="btn btn-primary">
                    Fechar
                </button>
            </Modal.Footer>
        </Modal>
    ]
}

export default CreateBranchHelper;


// WEBPACK FOOTER //
// ./src/components/tutorials/create_branch/index.jsx